import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManualInputUpdateRoutingModule } from './manual-input-update-routing.module';
import { ManualInputUpdateComponent } from './manual-input-update.component';
import { DxDataGridModule, DxChartModule, DxBulletModule, DxTemplateModule, DxPopupModule, DxTextAreaModule,  DxFileUploaderModule, DxDateBoxModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { TaskPopupModule } from '../../task/task-popup/task-popup.module';
import { FormsModule } from '@angular/forms';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { NumberBoxComponent } from 'src/app/components/number-box/number-box/number-box.component';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { BookmarkNewComponent } from "../../../widgets/bookmark-new/bookmark-new.component";

@NgModule({
	declarations: [ManualInputUpdateComponent],
	imports: [
    CommonModule,
    ManualInputUpdateRoutingModule,
    ContainerComponent,
    HelpButtonComponent,
    NumberBoxComponent,
    DxDataGridModule,
    DxChartModule,
    DevEpressCommonModule,
    DxDataGridModule,
    DxBulletModule,
    DxTemplateModule,
    TaskPopupModule,
    DxDateBoxModule,
    DxPopupModule,
    DxTextAreaModule,
    DxFileUploaderModule,
    FormsModule,
    DxTableControllerDirective, 
    BookmarkNewComponent
]
})
export class ManualInputUpdateModule { }
